module.exports = __webpack_public_path__ + "images/6ec89281.pay_4_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_4_kor.png
// module id = 497
// module chunks = 0